<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="pa-0 ma-0">
    <v-snackbar v-model="snackbar">

      {{ snackbartext }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>

    </v-snackbar>
    <v-form v-model="valid" lazy-validation ref="form" id="new-form">


      <v-row dense>
        <v-col cols="12">
          <v-sheet class="pt-4" elevation="1" color="#f3f3f3">
            <v-row class="px-4">
              <v-col md="2" sm="6" xs="6" cols="6" class="my-0 py-0">
                <v-combobox
                  dense
                  label="To:"
                  :rules="[required]"
                  v-model="clientid"
                  :items="clients"
                  ref="clientidselect"
                  filled
              />
            </v-col>
            <v-col md="2" sm="6" xs="6" cols="6" class="my-0 py-0">
              <v-text-field
                dense
                filled
                type="number"
                v-model="clientphone"
                :disabled="deliveryCheck(clientdelivery)"
                label="Phone number"
              >
              </v-text-field>
            </v-col>
            <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
              <v-text-field
                dense
                filled
                :disabled="deliveryCheck(clientdelivery)"
                v-model="clientaddress"
                label="Address"
              >
              </v-text-field>
            </v-col>
            <v-col md="1" sm="12" xs="12" cols="12" class="my-0 py-0">
              <v-text-field
                dense
                filled
                readonly
                disabled
                v-model="clientbalance"
                label="Balance"
              >
              </v-text-field>
            </v-col>
            <v-col
              md="1"
              sm="6"
              xs="6"
              cols="6"
              class="my-0 py-0"
              v-if="this.$route.query.do == 'edit'"
            >
              <v-text-field
                filled
                readonly
                disabled
                v-model="id"
                label="Invoice ID"
                dense
              />
            </v-col>
            <v-col
              md="1"
              sm="6"
              xs="6"
              cols="6"
              class="my-0 py-0"
              v-if="this.$route.query.do == 'edit'"
            >
              <v-text-field
                filled
                readonly
                disabled
                v-model="date"
                label="Date"
                dense
              />
            </v-col>



            <v-col md="3"
                   sm="12"
                   xs="12"
                   cols="12"
                   class="my-0 py-0"
                   v-if="this.$route.query.do === 'edit'">
              <v-select
                  dense
                  filled
                  v-if="this.$route.query.do === 'edit'"
                  v-model="ordertype"
                  item-text="text"
                  label="Platform"
                  :items="platforms"
              />
            </v-col>

            <v-col md="3" sm="12" xs="12" cols="12" class="my-0 py-0">
              <v-radio-group
                  dense
                  label="Invoice type"
                  v-model="invoicetype"
                  row
              >
                <v-radio label="Custom PC" color="red" value="pc"></v-radio>
                <v-radio
                    label="Parts"
                    color="green darken-3"
                    value="parts"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col
                md="2"
                sm="6"
                xs="6"
                cols="6"
                class="my-0 py-0"
            >
              <v-switch
                  v-model="paid"
                  label="Paid ?"
              />
            </v-col>
            <v-col
                v-if="this.$route.query.do === 'edit'"
                md="2"
                sm="6"
                xs="6"
                cols="6"
                class="my-0 py-0"
            >
              <v-checkbox
                  v-if="this.$route.query.do === 'edit'"
                  :disabled="this.readyChangePerm"
                  v-model="ready"
                  label="Ready ?"
              />
            </v-col>


          </v-row>
          <v-row class="px-4">
            <v-col cols="12" md="6" class="my-0 py-0">
              <v-text-field
                filled
                dense
                v-model="notes"
                placeholder="Customer name \ Phone \ Address ..."
                label="Notes"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="my-0 py-0">
              <v-text-field
                filled
                dense
                v-model="notes2"
                label="Installation instructions"
                placeholder="Games & Programs ..."
              ></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>

        <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
          <v-skeleton-loader
            v-if="loading"
            ref="skeleton"
            type="table-tbody"
            class="mx-auto"
          />
          <v-simple-table dense v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Category</th>
                  <th class="text-left">Part</th>
                  <th v-if="invoicetype === 'parts'" class="text-left">
                    Quantity
                  </th>
                  <th v-if="invoicetype === 'parts'" class="text-left">
                    Unit Price
                  </th>
                </tr>
              </thead>
              <tbody v-if="gotcats">
                <tr v-for="index in rows" :key="index">
                  <td class="align-center">
                    <v-autocomplete
                      dense
                      :items="cats"
                      v-model="selectedparts[index - 1].id"
                      @change="
                        getParts(selectedparts[index - 1].id, index - 1)
                      "
                    >
                    </v-autocomplete>
                  </td>
                  <td>
                    <v-autocomplete
                      dense
                      :items="selectedparts[index - 1].parts"
                      item-text="text"
                      item-value="value"
                      @change="changePrice(selectedparts[index - 1])"
                      v-model="selectedparts[index - 1].selected"
                    >
                    <template v-slot:item="{ item }">

                      <div class="d-flex justify-space-between align-center fill-width">
                        <div>
                            <div>{{ item.text }}</div>
                        </div>
                        <div>
                          <div class="d-flex align-center">
                            <div class="mr-1">
                                <v-chip small dark color="red">Cost: {{ item.cost }}</v-chip>
                            </div>
                            <div class="mr-1">
                                <v-chip small dark color="indigo">Price: {{ item.price }}</v-chip>
                            </div>
                            <div>
                                <v-chip small>Quan: {{ item.quan }}</v-chip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    </v-autocomplete>
                  </td>
                  <td v-if="invoicetype === 'parts'">
                    <v-text-field
                      dense
                      v-model="selectedparts[index - 1].quan"
                      type="number"
                    />
                  </td>
                  <td v-if="invoicetype === 'parts'">
                    <v-text-field
                      dense
                      v-model="selectedparts[index - 1].unitprice"
                      type="number"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-row>
            <v-col class="mx-4">
              <v-btn color="blue" @click="addMore()" class="white--text">
                <v-icon dark class="me-2">mdi-plus</v-icon>
                Add more rows
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="px-3">

            <v-footer color="indigo" dark :app="stickFooter" inset v-resize="checkScreen">
              <v-row dense>
                <v-col cols="6" xs="6" md="2">
                  <v-text-field
                      ref="totalfield"
                      v-model="total"
                      type="number"
                      outlined
                      required
                      :rules="priceRules"
                      label="Total amount (USD)"
                      style="font-weight: bold; font-size: larger;"
                      :disabled="partsorcustom"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6" md="2">
                  <v-text-field
                      outlined
                      v-model="discount"
                      style="font-weight: bold; font-size: larger;"
                      label="Discount amount (Optional)"
                      type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" xs="6" md="2">
                  <v-select
                      outlined
                      return-object
                      label="Shipping"
                      :items="shippingtypes"
                      v-model="shippingtype"
                  />
                </v-col>

                <v-col cols="6" xs="6" md="2">
                  <v-text-field
                      outlined
                      v-model="grandcost"
                      readonly
                      disabled
                      type="number"
                      style="font-weight: bold; font-size: larger;"
                      label="Total cost (USD)"
                  />
                </v-col>

                <v-col cols="6" xs="6" md="2">
                  <v-text-field
                      outlined
                      v-model="grandtotal"
                      readonly
                      disabled
                      type="number"
                      style="font-weight: bold; font-size: larger;"
                      label="Grand total (USD)"
                  />
                </v-col>
                <v-col cols="6" xs="6" md="2">
                  <v-text-field
                      outlined
                      v-model="grandtotaliqd"
                      readonly
                      disabled
                      style="font-weight: bold; font-size: larger;"
                      label="Grand total (IQD)"
                  />

                </v-col>
              </v-row>
            </v-footer>
          </v-row>
          <v-row class="px-4">
            <v-col cols="6">
              <v-btn
                large
                block
                form="new-form"
                @click="validate(false)"
                :disabled="$route.query.do === 'edit' ? disabled : false"
                :loading="loadingbtn"
                color="success"
                class="white--text"
              >
                <v-icon dark class="me-2">mdi-check</v-icon>
                Save
              </v-btn>
            </v-col>

            <v-col cols="6">
              <v-btn
                  large
                  block
                  form="new-form"
                  @click="validate(true)"
                  :disabled="$route.query.do === 'edit' ? disabled : false"
                  :loading="loadingbtn"
                  color="success"
                  class="white--text"
              >
                <v-icon dark class="me-2">mdi-printer</v-icon>
                Save & Print
              </v-btn>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>
    </v-row>


  </v-form>
</v-container>
</template>

<script>
import { __HTTP, FormHeader, __HAS_PERM,__HAS_INLINE_PERM,_numFormat } from "@/utils/utils.js";

export default {
inject: ["theme"],
name: "SalesTajmeea",
mounted() {
  //console.log("Mounted");
  //this.$store.state.title = "New Invoice " + "(" + this.getOrderType + ")";
},
created() {


  if (this.$route.query.do === "edit") {
    this.isedit = true;
    this.getOrderDetails();
    this.$store.state.title = "Edit Invoice - " + this.$route.query.id;
    this.checkReadyPermission()
    this.getClients()
  } else {
    this.getCats();
    this.getInfo();
    this.$store.state.title = "New Invoice " + "(" + this.getOrderType + ")";
  }
  //console.log("Platform", this.$route.query.ordertype)
},
computed: {
  disabledOnEdit() {
    if (this.isedit) {
      return true
    } else {
      return false
    }
  },
  clientdelivery: {
    get: function() {
      return this.clientid != null ? this.clientid.delivery : "0";
    },
    set: function(v) {
      this.cdelivery = v;
    }
  },
  clientphone: {
    get: function() {
      return this.clientid != null ? this.clientid.phone : "";
    },
    set: function(v) {
      this.cphone = v;
    }
  },
  clientbalance() {
    return this.clientid != null ? this.clientid.balance : "";
  },
  clientaddress: {
    get: function() {
      return this.clientid != null ? this.clientid.address : "";
    },
    set: function(v) {
      this.caddress = v;
    }
  },
  grandtotaliqd() {
    return _numFormat(this.$store.state.rate * this.grandtotal);
  },

  grandcost() {
    var total = 0;
    this.selectedparts.forEach(el => {
          if (el.selected != null) {

             let index = el.parts.findIndex(o => o.value == (typeof(el.selected) === "object" ? el.selected.value : el.selected))
             //console.log(el);
             if (index != -1)
              total += parseInt(el.parts[index].cost * el.quan);
          }
        });
        return total;
  },
  total: {
    get: function() {
      var xxx = 0;
      if (this.invoicetype == "pc") {
        //console.log(this.shippingtypes);
        //console.log("Types",this.shippingtypes[index]);
        xxx = this.mytotal;
      } else {
        var total = 0;
        this.selectedparts.forEach(el => {
          if (el.selected != null) {
            // console.log(el);
            total += parseInt(el.quan * el.unitprice);
          }
        });
        //this.total = total;
        xxx = total;
      }
      return xxx;
    },
    set: function(newValue) {
      this.mytotal = newValue;
    }
  },
  grandtotal() {
    let index = this.shippingtypes.findIndex(
      o => o.value == this.shippingtype.value
    );
    var xxx = 0;
    if (this.invoicetype == "pc") {
      //console.log(this.shippingtypes);
      //console.log("Types",this.shippingtypes[index]);
      xxx =
        parseInt(this.total == "" ? 0 : this.total) -
        parseInt(this.discount == "" ? 0 : this.discount) +
        parseInt(this.shippingtypes[index].price);
    } else {
      var total = 0;
      this.selectedparts.forEach(el => {
        if (el.selected != null) {
          // console.log(el);
          total += parseInt(el.quan * el.unitprice);
        }
      });
      //this.total = total;
      xxx =
        total -
        parseInt(this.discount == "" ? 0 : this.discount) +
        parseInt(this.shippingtypes[index].price);
    }
    return xxx;
  },
  getOrderType() {
    if (this.ordertype == 1) {
      return "Floria";
    } else if (this.ordertype == 2) {
      return "Iraq IT";
    } else if (this.ordertype == 3) {
      return "Tajmeaa";
    } else {
      return "Future Tech";
    }
  },
  partsorcustom() {
    if (this.invoicetype === "parts") {
      return true;
    } else {
      return false;
    }
  }
},
methods: {
  getPlatforms() {
    __HTTP("?do=getplatforms", "", FormHeader, res => {
      //this.isloading = false
      this.platforms = res;
    });
  },
  getClients() {
    this.loading = true;
    __HTTP("?do=getclients", "", FormHeader, res => {
      this.getPlatforms();
      this.isloading = false;
      this.clients = res;
    });
  },
  checkScreen() {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        this.stickFooter = false
        break;
      case 'sm':
        this.stickFooter = false
        break;
      case 'md': this.stickFooter = true
        break;
      case 'lg': this.stickFooter = true
        break;
      default: this.stickFooter = true
        break;
    }
  },
  checkReadyPermission(){
   __HAS_INLINE_PERM(53, this.$store.state.loggedUser.id,()=> {
      this.readyChangePerm = false
   });
  },
  deliveryCheck(status) {
    if (this.isedit) {
      return true
    } else if (status === "1") {
      return true
    } else {
      return false
    }
  },
  changePrice(p) {
    var ii = this.selectedparts.indexOf(p);

    var index = p.parts.findIndex(o => o.value == p.selected);
    if (p.parts[index].quan <= 0) {
      // Uncomment to prevent selling zero or minus quantity
      // alert("يرجى مراجعة المخزن , الكمية غير متوفرة");
     if (Array.isArray(this.selectedparts[ii].selected)) {
      this.selectedparts[ii].selected.splice(index,1);
     } else {
       // Uncomment to prevent selling zero or minus quantity
       // this.selectedparts[ii].selected = [];
     }
      __HTTP("?do=sendemail",JSON.stringify({
        item: p.parts[index]
      }),FormHeader,() => {
      //  console.log(res);
      });
    } else {
      this.selectedparts[ii].unitprice = p.parts[index].cost;
    }
    //console.log(p.parts[index].cost);
  },
  required(value) {
    if (value instanceof Array && value.length == 0) {
      return "Required.";
    }
    return !!value || "Required.";
  },
  validate(print) {
    // if (this.$refs.form.validate()){
    if (this.total > 0) {
      if( this.clientid !== null ) {
        this.send(print);
      } else {
        this.snackbar = true
        this.snackbartext = "Please select a client first"
        this.$refs.clientidselect.focus();
      }
    } else {
      this.snackbar = true
      this.snackbartext = "Please enter a total amount"
      this.$refs.totalfield.focus();
    }

    // } else {
    //  alert("Error");
    //}
  },
  getOrderDetails() {
    __HTTP(
      "?do=getorder",
      JSON.stringify({ id: this.$route.query.id }),
      FormHeader,
      res => {
        //console.log(res);
        this.gotcats = true;
        if (res.auth) {
          this.cats = res.cats;
          this.shippingtypes = res.shippingtypes;
          this.rows = res.items.length;
          this.selectedparts = new Array();
          res.items.forEach(e => {
            this.selectedparts.push({
              id: e.catid,
              parts: e.parts,
              selected: e.item,
              quan: e.quan,
              unitprice: e.unitprice
            });
          });
          this.shippingtype = res.shippingtype;
          this.id = res.id;
          this.clientid = res.clientid;
          this.total = res.total;
          this.discount = res.discount;
          this.disabled = res.disable;
          this.valid = !res.disable;
          this.invoicetype = res.invoicetype === "0" ? "pc" : "parts";
          this.paid = res.paid !== "0";
          this.ready = res.ready !== "0";
          this.date = res.adddate;
          this.notes = res.notes;
          this.notes2 = res.notes2;
          this.ordertype = res.ordertype;
          this.loading = false;
        } else {
          //alert("No such Order ...");
          //this.$router.pop();
        }
      }
    );
  },
  getInfo() {
    __HTTP("?do=getinfo", "", FormHeader, d => {
      this.shippingtypes = d.shippingtypes;
      this.shippingtype = d.shippingtypes[0];
      this.id = d.id;
      this.clients = d.clients;
    });
  },
  send(print) {
    //console.log("PLATFORM ID", this.platform)
    let v = [];
    this.disabled = true;
    this.loadingbtn = true;
    this.selectedparts.forEach(el => {
      if (el.selected != null) {
        v.push({ info: el.selected, quan: el.quan, unitprice: el.unitprice });
      }
    });
    const x = JSON.stringify({
      client: this.clientid,
      clientphone: this.cphone,
      clientaddress: this.caddress,
      parts: v,
      notes: this.notes,
      notes2: this.notes2,
      shippingtype: this.shippingtype.value,
      invoicetype: this.invoicetype,
      paid: this.paid ? "1" : "0",
      ready: this.ready ? "1" : "0",
      ordertype: this.ordertype,
      total: this.total,
      gtotal: this.grandtotal,
      discount: this.discount,
      id: this.$route.query.id,
    });
    //console.log(x);
    __HAS_PERM(this.isedit ? 31 : 3, this.$store.state.loggedUser.id, () => {
      __HTTP(
        "?do=" + (this.isedit ? "edit" : "new") + "&type=sales",
        x,
        FormHeader,
        res => {
          this.disabled = false;
          //
          // console.log(res);
          if (res.auth === true && print === false) {
           // console.log(res);
            // If everything ok
            this.$router.push({ path: "/list-sales" });
          } else {
            this.$router.push({ path: "/print" ,query: { id: res.id } });
          }
        }
      );
    });
    //console.log("JSON",x);
  },
  addMore() {
    this.selectedparts.push({
      id: null,
      parts: [],
      selected: null,
      quan: 1,
      unitprice: 0
    });
    this.rows++;
  },
  getParts: function(val, i) {
    __HTTP("?do=getparts", JSON.stringify({ id: val }), FormHeader, res => {
      this.selectedparts[i].parts = res;
      this.selectedparts[i].unitprice = 0;
    });
  },

  getExchangeRate() {
    __HTTP("?do=getexchangerate", JSON.stringify(), FormHeader, res => {
      this.exchangerate = res.rate;
    });
  },
  getCats() {
    __HTTP("?do=getcats", "", FormHeader, res => {
      //console.log(res);
      this.cats = res;
      this.selectedparts = new Array();
      var ii = 0;
      for (let index = 0; index < res.length; index++) {
        //const element = res[index];
        if (res[index].defaultrows == 1) {
          ii++;
        this.selectedparts.push({
          id: res[index].value,
          parts: [],
          selected: null,
          quan: 1,
          unitprice: 0
        });
        this.getParts(res[index].value, index);
        }
      }
      //console.log(this.selectedparts);
      this.rows = ii;
      this.gotcats = true;
      this.loading = false;
    });
  }
},
beforeRouteLeave (to, from , next) {
  if (to.name !== "Print" && to.name !== "List Sales" ) {
    const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  } else {
    next()
  }
},
data() {
  return {
    readyChangePerm: true,
    stickFooter: true,
    cdelivery: "",
    cphone: "",
    caddress: "",
    mytotal: 0,
    valid: true,
    gotcats: false,
    insertedid: "0",
    rows: 0,
    platform: null,
    snackbar: false,
    snackbartext: "",
    isedit: false,
    platforms: [],
    ordertype: this.$route.query.ordertype,
    ordertypelabel: "",
    invoicetype: this.$route.query.invoicetype,
    cats: [],
    clients: [],
    selectedparts: [],
    quan: [],
    unitprice: [],
    clientid: null,
    date: new Date().toISOString().substr(0, 10),
    discount: 0,
    disabled: false,
    shippingtypes: [],
    notes: "",
    notes2: "",
    shippingtype: null,
    id: 0,
    paid: false,
    ready: false,
    exchangerate: "---",
    loadingbtn: false,
    loading: true,
    priceRules: [
      v => !!v || "This field is required",
      v =>
        (v && v.length >= 1) ||
        "Price must be greater equal or greater than 1 digit."
    ],
    titleRules: [
      v => !!v || "Customer name is required",
      v =>
        (v && v.length >= 1) ||
        "Customer name must be equal or greater than 1 character"
    ]
  };
}
};
</script>

<style scoped>
.fill-width { width: 100%}
</style>
